export default {
    url: '/privileges',
    template: '<manage-permissions-roles-detail-privileges role="vm.role"/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/roles/detail/privileges/index.js